module.exports = __webpack_public_path__ + "img/1.f066de3f.png";